import { useEffect, useState } from 'react';
import ApiService from '../../../../../services/ApiService';
import { NcmCatalogoPosicao } from './types';

export interface NcmCatalogoResultado {
  id: number;
  ncm: string;
  descricao: string | null;
  jaCadastrado: boolean;
}

const BUSCA_LIMITE = 60;
const BUSCA_ATRASO_MS = 300;

const isResultado = (v: unknown): v is NcmCatalogoResultado =>
  !!v && typeof v === 'object' && 'ncm' in v && 'id' in v;

export function useNcmCatalogo(termo: string) {
  const [sugestoes, setSugestoes] = useState<NcmCatalogoPosicao[]>([]);
  const [resultados, setResultados] = useState<NcmCatalogoResultado[]>([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    let ativo = true;
    ApiService.fiscal
      .getNcmCatalogoSugestoes()
      .then((r) => {
        if (ativo) setSugestoes(r.data?.posicoes ?? []);
      })
      .catch((error: unknown) => console.error('Erro ao buscar sugestões do catálogo:', error));
    return () => {
      ativo = false;
    };
  }, []);

  useEffect(() => {
    const q = termo.trim();
    if (!q) {
      setResultados([]);
      return;
    }
    let ativo = true;
    const timer = setTimeout(() => {
      setCarregando(true);
      ApiService.stockLookup
        .searchNcmCatalogo(q, BUSCA_LIMITE, 0)
        .then((r: { data?: unknown }) => {
          if (!ativo) return;
          const lista: unknown[] = Array.isArray(r?.data) ? r.data : [];
          setResultados(lista.filter(isResultado));
        })
        .catch((error: unknown) => console.error('Erro ao buscar no catálogo de NCM:', error))
        .finally(() => {
          if (ativo) setCarregando(false);
        });
    }, BUSCA_ATRASO_MS);
    return () => {
      ativo = false;
      clearTimeout(timer);
    };
  }, [termo]);

  return { sugestoes, resultados, carregando };
}
